import { render, staticRenderFns } from "./LedSolutionList.vue?vue&type=template&id=fc2895a0&scoped=true&"
import script from "./LedSolutionList.vue?vue&type=script&lang=js&"
export * from "./LedSolutionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2895a0",
  null
  
)

export default component.exports